import React, { useContext } from 'react';
import {
  Text,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components';
import { AnimationCard, Message } from 'botframework-directlinejs';
import { Checkmark20Filled } from '@fluentui/react-icons';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';

export const useLoadingIntentStyles = makeStyles({
  loadingIntentContent: {
    fontSize: tokens.fontSizeBase200,
    textAlign: 'center',
    width: '100%',
    display: 'flex',
    paddingTop: tokens.spacingVerticalM,
  },
  loadingIntentText: {
    marginLeft: tokens.spacingVerticalSNudge,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
    fontWeight: 600,
  },
});

export const LoadingIntent: React.FC<{ activity: Message }> = ({ activity }) => {
  const i18n = useContext(I18nContext) as I18nModel;
  const styles = useLoadingIntentStyles();

  const { attachments } = (activity as Message);

  return attachments?.map((attachment, index) => {
    const animationCard = attachment as AnimationCard;

    if (animationCard.content.text !== 'GeneratingAnswers') {
      return null;
    }

    return (
      // eslint-disable-next-line react/no-array-index-key
      <div key={index} className={mergeClasses(styles.loadingIntentContent, 'loading-Intent-content')}>
        <Checkmark20Filled style={{ overflow: 'initial' }} color="green" />
        <Text className={mergeClasses(styles.loadingIntentText, 'loading-intent-text')}>{i18n.getString(_TL_('Generating answers for you...'))}</Text>
      </div>
    );
  });
};
